import Spinner from '@atlaskit/spinner';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
        display: block;
        text-align: center;
        margin-bottom: 14px;
    }
`;

export default () => {
    return (
        <Wrapper>
            <Spinner size="large" />
        </Wrapper>
    );
};
